import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const PinPageMain = React.lazy(() => import('./main/PinPageMain'));
const SuccessPageMain = React.lazy(() => import('./main/SuccessPageMain'));

function App() {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<PinPageMain />} />
          <Route path="/success" element={<SuccessPageMain />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;